import React from 'react';
import { motion, AnimatePresence, useReducedMotion } from 'framer-motion';
import { dropdownPanelVariants, dropdownTransition } from './dropdownMotion';
import { DROPDOWN_Z_INDEX } from '../../hooks/useFloatingPanelPosition';

function DropdownPanel({
  open,
  children,
  className = '',
  align = 'left',
  origin = 'top',
  style,
}) {
  const reducedMotion = useReducedMotion();
  const transition = dropdownTransition(reducedMotion);
  const alignClass =
    align === 'right' ? 'right-0' : align === 'center' ? 'left-1/2 -translate-x-1/2' : 'left-0';
  const originClass = origin === 'bottom' ? 'origin-bottom' : 'origin-top';

  return (
    <AnimatePresence>
      {open ? (
        <motion.div
          initial="hidden"
          animate="visible"
          exit="exit"
          variants={dropdownPanelVariants}
          transition={transition}
          style={{ zIndex: DROPDOWN_Z_INDEX, ...style }}
          className={`dropdown-panel-ios absolute top-full left-0 mt-1 ${originClass} ${alignClass} ${className}`.trim()}
        >
          {children}
        </motion.div>
      ) : null}
    </AnimatePresence>
  );
}

export default DropdownPanel;
